import React from "react";
import { Box, Button, Link, List, ListItem } from "@chakra-ui/react";
import { MDXProvider } from "@mdx-js/react";
import { Large, P } from "../components/Type";
import Prism from "prismjs";
import { useCopyToClipboard } from "react-use";
import { useClipboard } from "use-clipboard-copy";
Prism.manual = true;

require("prismjs/components/prism-python");

const components = {
  h1: Large,
  h2: ({ children }) => {
    return (
      <Large borderBottom="1px solid #333" fontSize={["xl", "2xl"]}>
        {children}
      </Large>
    );
  },
  h3: ({ children }) => {
    return <Large fontSize={["l", "xl"]}>{children}</Large>;
  },
  h4: ({ children }) => {
    return <Large fontSize={["md", "l"]}>{children}</Large>;
  },
  a: (props) => {
    return <Link {...props} textDecoration="underline"></Link>;
  },
  p: P,
  ul: ({ children }) => (
    <List as="ul" styleType="disc" stylePosition="inside" mb="5">
      {children}
    </List>
  ),
  ol: ({ children }) => (
    <List as="ol" styleType="decimal" mb={3} stylePosition="inside">
      {children}
    </List>
  ),
  pre: ({ children }) => {
    const { children: code, className } = children.props;
    const clip = useClipboard({ copiedTimeout: 500 });

    const handleClick = React.useCallback(() => {
      clip.copy(code); // programmatically copying a value
    }, [clip.copy, code]);

    return (
      <Box position="relative" as="pre" className={className} maxHeight="400px">
        <>
          {children}
          <Button
            variant="ghost"
            position="absolute"
            disabled={clip.copied}
            _active={{}}
            _hover={{}}
            top="0"
            right="0"
            marginRight="1"
            marginTop="1"
            height="fit-content"
            onClick={handleClick}
          >
            {clip.copied ? "Copied!" : "Copy"}
          </Button>
        </>
      </Box>
    );
  },
  code: ({ className = "language-markup", children, ...props }) => {
    const lang = className.replace("language-", "");
    const html = Prism.highlight(children, Prism.languages[lang], lang);
    return (
      <Box
        as="code"
        dangerouslySetInnerHTML={{ __html: html }}
        className={className}
      ></Box>
    );
  },
  li: ListItem,
};

const MDXWrapper = ({ children, ...props }) => {
  return (
    <MDXProvider components={components} {...props}>
      {children}
    </MDXProvider>
  );
};

export { MDXWrapper };
